export const locales = [
  {
    key: 'en',
    label: 'English',
  },
  {
    key: 'es',
    label: 'Español',
  },
  {
    key: 'de',
    label: 'Deutsch',
  },
  {
    key: 'fr',
    label: 'Français',
  },
  {
    key: 'ja',
    label: '日本語',
  },
  {
    key: 'pt',
    label: 'Português',
  },
  {
    key: 'ru',
    label: 'Русский',
  },
  {
    key: 'tr',
    label: 'Türkçe',
  },
  {
    key: 'uk',
    label: 'українська',
  },
  {
    key: 'zh',
    label: '中文',
  },
]
